import { render } from "./CreditsHistory.vue?vue&type=template&id=60dbeef4&scoped=true"
import script from "./CreditsHistory.vue?vue&type=script&lang=js"
export * from "./CreditsHistory.vue?vue&type=script&lang=js"

import "./CreditsHistory.vue?vue&type=style&index=0&id=60dbeef4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60dbeef4"]])

export default __exports__